/* PDP hover zoom — magnifies the gallery image toward the cursor on hover.
   Desktop (fine pointer) only; click-to-open PhotoSwipe gallery is untouched.
   Delegated from the <zoom-images> container so re-rendered slides keep working. */
!(function () {
  'use strict';

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var SCALE = 1.75;

  function attach(zoom) {
    if (zoom.dataset.hoverZoomBound) return;
    zoom.dataset.hoverZoomBound = 'true';

    zoom.addEventListener('mousemove', function (e) {
      var photo = e.target.closest('[data-zoom-image]');
      if (!photo || !zoom.contains(photo)) return;
      var img = photo.querySelector('img');
      if (!img) return;
      var rect = photo.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(' + SCALE + ')';
    });

    zoom.addEventListener(
      'mouseout',
      function (e) {
        var photo = e.target.closest('[data-zoom-image]');
        if (!photo) return;
        // still inside the same photo (moved between children) — keep zooming
        if (e.relatedTarget && photo.contains(e.relatedTarget)) return;
        var img = photo.querySelector('img');
        if (!img) return;
        img.style.transform = '';
        img.style.transformOrigin = '';
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('zoom-images').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
